<div class="overflow-mh31" *ngIf="aiAccountsSummaries[summariesYearAccount]; else noSummaries">
  <div *ngIf="aiAccountsSummaries[summariesYearAccount][0].business_model?.length" class="card mb-2">
    <h5 class="card-header">Business Model</h5>
    <span class="pl-3 p-2">{{aiAccountsSummaries[summariesYearAccount][0].business_model}}</span>
  </div>

  <div class="d-sm-flex flex-sm-wrap">
    <div *ngIf="aiAccountsSummaries[summariesYearAccount][0].strategic_goals?.length" class="card px-0 mr-0 mr-sm-1 overflow-auto" [ngClass]="this.aiAccountsSummaries[this.summariesYearAccount][0].pains_challenges?.length < 1 ? 'col-sm-12' : 'flex-2-cards'">
      <h5 class="card-header">Strategic Goals</h5>
        <span class="pl-4 p-1" *ngFor="let goal of aiAccountsSummaries[summariesYearAccount][0].strategic_goals">
          {{goal.text}}
          <a [href]="getSummaryURL(goal.page)" target="_blank"><i class="fal fa-external-link"></i></a>
        </span>
    </div>

    <div *ngIf="aiAccountsSummaries[summariesYearAccount][0].pains_challenges?.length" class="card px-0 mt-sm-2 mt-md-0" [ngClass]="this.aiAccountsSummaries[this.summariesYearAccount][0].strategic_goals?.length < 1 ? 'col-sm-12' : 'flex-2-cards'">
      <h5 class="card-header">Challenges</h5>
      <span class="pl-4 p-1" *ngFor="let pain of aiAccountsSummaries[summariesYearAccount][0].pains_challenges">
        {{pain.text}}
        <a [href]="getSummaryURL(pain.page)" target="_blank"><i class="fal fa-external-link"></i></a>
      </span>
    </div>

    <div *ngIf="aiAccountsSummaries[summariesYearAccount][0].future_events?.length" class="card col-sm-12 px-0 mt-2">
      <h5 class="card-header">Future Events</h5>
      <span class="pl-4 p-1" *ngFor="let event of aiAccountsSummaries[summariesYearAccount][0].future_events">
        {{event.text}}
        <a [href]="getSummaryURL(event.page)" target="_blank"><i class="fal fa-external-link"></i></a>
      </span>
    </div>
  </div>

  <div *ngIf="aiAccountsSummaries[summariesYearAccount][0].bullets && isFullSummariesAvailable(aiAccountsSummaries[summariesYearAccount][0].bullets)"
 class="mt-2" [ngClass]="{'fullSummary': fullSummaryVisible[summariesYearAccount]}">
      <button class="basic-button-base button-dark">
        <a class="text-decoration-none text-reset" data-toggle="collapse" data-target="#fullSummaries"
          aria-expanded="false" aria-controls="fullSummaries" (click)="showFullDetails(summariesYearAccount, $event)">
          Full Summaries
        </a>
        <i *ngIf="fullSummaryVisible[summariesYearAccount]" class="fal fa-angle-double-down fa-scroll-down" ></i>
      </button> 
  
  </div>

  <div class="collapse fade card-body border" id="fullSummaries">
    <div class="" *ngFor="let category of aiAccountsSummaries[summariesYearAccount][0].bullets | keyvalue">
      <span class="badge badge-orange">{{category?.key}}
      </span>
      <br>
      <ul>
        <li *ngFor="let bullet of category?.value">
          {{bullet.text}}
          <a [href]="getSummaryURL(bullet.page)" target="_blank"><i class="fal fa-external-link"></i></a>
        </li>
      </ul>
    </div>
  </div>
</div>
<ng-template #noSummaries>
  <p class="p-4 border bg-light">No summaries have been generated for this year.
  </p>
</ng-template>